import React from 'react';

import KPIForm from './KPIForm';
import { SAME_AS_FIRST } from './constants';
import { kpiSeriesSchema } from './schemas';

const defaultValues = kpiSeriesSchema.default();

export const KPIFormCreate = ({
  firstTableRowValues,
  onSubmit,
  onClose,
  firstEntity,
  onExited,
  open,
}) => {
  return (
    <KPIForm
      title={'Add Series'}
      onClose={onClose}
      defaultValues={defaultValues}
      initialValues={
        firstTableRowValues
          ? { ...firstTableRowValues, [SAME_AS_FIRST]: true }
          : defaultValues
      }
      firstTableRowValues={firstTableRowValues}
      asFirstTableRowDisabled={firstEntity}
      onSubmit={onSubmit}
      onExited={onExited}
      open={open}
    />
  );
};

export const KPIFormEdit = ({
  initialValues,
  firstTableRowValues,
  onSubmit,
  onClose,
  firstEntity,
  onExited,
  open,
}) => {
  return (
    <KPIForm
      title={'Edit Series'}
      onClose={onClose}
      defaultValues={defaultValues}
      initialValues={initialValues}
      firstTableRowValues={firstTableRowValues}
      asFirstTableRowDisabled={firstEntity}
      onSubmit={onSubmit}
      onExited={onExited}
      open={open}
    />
  );
};

export const KPIFormDuplicate = ({
  initialValues,
  firstTableRowValues,
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  return (
    <KPIForm
      title={'Duplicate Series'}
      onClose={onClose}
      defaultValues={defaultValues}
      initialValues={initialValues}
      firstTableRowValues={firstTableRowValues}
      onSubmit={onSubmit}
      onExited={onExited}
      open={open}
    />
  );
};
